import { Component, Input } from '@angular/core';
import { logTypes } from 'app/helpers/log-events';
@Component({
  standalone: false,
  selector: 'app-user-activity',
  templateUrl: './user-activity.component.html',
  styleUrls: ['./user-activity.component.scss']
})
export class UserActivityComponent {
  @Input()
  activityLogs: any;
  @Input()
  userName: any;
  @Input() loading: boolean;
 
  category(type: string){
    if(logTypes.warning.some((w) => w.eventCode === type))
     {return 'warning_amber';}
    else if(logTypes.failure.some((f) => f.eventCode === type))
      {return 'error_outline';}
    else if (logTypes.success.some((s) => s.eventCode === type))
     {return 'check_circle_outline';}
    else
      {return 'info_outline';}
  }
}
